module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-barra-redonda.600c4e3d.jpg";